export const MISSING_DATA_ACTIONS = {
  GET_MISSING_DATA: 'GET_MISSING_DATA',
  GET_MISSING_DATA_SUCCESS: 'GET_MISSING_DATA_SUCCESS',
  GET_MISSING_DATA_ERROR: 'GET_MISSING_DATA_ERROR',
  GET_MISSING_DATA_CLEAN_STATE: 'GET_MISSING_DATA_CLEAN_STATE',
};
// =========================================================================
export const getMissingData = (params) => ({
  type: MISSING_DATA_ACTIONS.GET_MISSING_DATA,
  payload: params,
});
export const getMissingDataSuccess = (data) => ({
  type: MISSING_DATA_ACTIONS.GET_MISSING_DATA_SUCCESS,
  payload: data,
});
export const getMissingDataError = ({ message }) => ({
  type: MISSING_DATA_ACTIONS.GET_MISSING_DATA_ERROR,
  payload: message,
});
export const getMissingDataCleanState = () => ({
  type: MISSING_DATA_ACTIONS.GET_MISSING_DATA_CLEAN_STATE,
});
// =========================================================================
